import moment from "moment";
import React, { useEffect, useState } from "react";
import AssetCardContent from "./AssetCardContent";
import { IStrapiAssetCard } from "@ts/common-types";
import { FaExpand } from "react-icons/fa";

export const AssetCard: React.FC<IStrapiAssetCard> = ({
    assetResponse,
    assetClickHandler,
    onAssetExpandClickHandler,
}) => {
    const fileExt =
        assetResponse.attributes.asset.data.attributes.ext.toLowerCase();
    const fileMime = assetResponse.attributes.asset.data.attributes.mime;
    const fileURL = assetResponse.attributes.asset.data.attributes.url;
    const fileSrc = fileURL;
    const fileName = assetResponse.attributes.name;
    const [counter, setCounter] = useState<number>(0);

    useEffect(() => {
        assetClickHandler();
        // eslint-disable-next-line
    }, [counter]);

    return (
        <>
            <div
                className="col"
                style={{ marginBottom: "20px" }}
                onClick={() => setCounter((prev: number) => prev + 1)}
            >
                <div className="card assetCard anchor-class"
                    style={{
                        fontSize: "12px",
                        height: "100%",
                        width: "100%"
                    }}
                    data-id={assetResponse.id}
                >
                    <FaExpand className="text-primary"
                        style={{
                            position: "absolute",
                            zIndex: "5",
                            top: "10px",
                            right: "10px",
                        }}
                        onClick={() =>
                            onAssetExpandClickHandler({
                                fileExt,
                                fileMime,
                                fileURL,
                                fileSrc,
                                fileName,
                            })
                        }
                    />
                    <AssetCardContent {...{ fileExt, fileMime, fileSrc }} />
                    <div className="card-footer bg-light">
                        <div className="display-block">{fileName} </div>
                        <small className="text-decoration-none text-secondary">
                            {moment(
                                assetResponse.attributes.asset.data.attributes
                                    .createdAt
                            ).format("MMMM Do YYYY")}
                            <br />
                            Type : {assetResponse.attributes.type}
                        </small>
                    </div>
                </div>
            </div>
        </>
    );
};
